/**
 * Eventos WebSocket.
 *
 * O servidor faz broadcast de COMANDOS, nunca da timeline inteira: um projeto grande
 * tem megabytes de JSON, e um comando tem centenas de bytes.
 */
export const WS_EVENTS = {
    JOB_PROGRESS: 'job.progress',
    JOB_COMPLETED: 'job.completed',
    JOB_FAILED: 'job.failed',
    MEDIA_READY: 'media.ready',
    MEDIA_FAILED: 'media.failed',
    SEQUENCE_COMMAND: 'sequence.command',
    TRANSCRIPT_READY: 'transcript.ready',
    CHANGESET_READY: 'changeset.ready',
    EXPORT_READY: 'export.ready',
    PRESENCE: 'presence',
};
/** Canal Redis por projeto: permite que qualquer réplica da API entregue o evento. */
export function projectChannel(projectId) {
    return `ee:project:${projectId}`;
}
//# sourceMappingURL=events.js.map